import { useEffect, useState } from "react";
import { api } from "./api";

export function usePurchaseOfferRequirements(enabled: boolean, itemId?: string) {
  const [requirements, setRequirements] = useState<{ active: boolean; fields: string[]; missingFacts?: string[] } | null>(null);
  const [error, setError] = useState<string | null>(null), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    let active = true; setRequirements(null); setError(null);
    api.purchaseOfferRequirements(itemId).then(current => {
      if (typeof current?.active !== "boolean" || !Array.isArray(current.fields)) throw new Error("Purchase requirements are unavailable. Retry loading.");
      if (active) setRequirements(current);
    }).catch(failure => { if (active) setError(failure instanceof Error ? failure.message : "Purchase requirements could not be loaded."); });
    return () => { active = false; };
  }, [enabled, attempt, itemId]);
  return { requirements, error, retry: () => setAttempt(current => current + 1) };
}
